import React, { Component } from "react";

export default class CardEntidad extends Component {

  constructor(props) {
    super(props);
    this.state = {
      itemSelected: props.itemSelected,
      img: props.img,
      label: props.label,
      codigo: props.codigo,
      valorSeleccionado: ""

    };
  }

  componentDidMount() {

  }

  handleChange = (e) => {
    var valores = e.servicio;
    var pathEntidad = e.pathLogo;
    this.setState({
      valorSeleccionado: e.desEntidad
    });

    this.props.selectorValue(valores, e.desEntidad, pathEntidad );

  };


  render() {
    var valor = this.props.itemSelected;
  
    return (
      <div className="col-lg-2 col-6">
        <div className="info-box pago-servicio-caja" onClick={(e) => { this.handleChange(valor) }}>
          <span className="pago-servicio-caja-link">
            <div className="image">
              <img src={valor.pathLogo} className="pago-servicio-img" alt={valor.desEntidad}/>              
            </div>
            <p className="pago-servicio-img-label">{valor.desEntidad}</p>
          </span>
        </div>
      </div>
    )

  }
}


